import { Paper, PaperProps, styled } from '@mui/material';

export const PaperForm = styled(Paper)<PaperProps>(({ theme }) => ({
  padding: theme.spacing(5, 3),
  marginBottom: theme.spacing(3),
  '& svg': {
    color: theme.palette.grey[500],
  }
}));